import { Grid, Stack } from '@mui/material';
import { WsButton } from 'wisestep-base';

const ManagePlanButton = ({
  onClick,
  text,
  isOutlined = false,
  mt = 0,
}: {
  onClick: () => void;
  text: string;
  isOutlined?: boolean;
  mt?: number;
}) => (
  <Grid container>
    <Grid item xs={2}></Grid>
    <Grid item xs={8}>
      <Stack direction="column" spacing={1.2} mt={mt}>
        <WsButton variant={isOutlined ? 'outlined' : 'contained'} onClick={onClick}>
          {text}
        </WsButton>
      </Stack>
    </Grid>
    <Grid item xs={2}></Grid>
  </Grid>
);

export default ManagePlanButton;
